import { ja } from "date-fns/locale";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import TextField from "../TextField";
import { InputBaseComponentProps, SxProps, Theme } from "@mui/material";

type DateInputProps = {
  label?: string;
  value: string | undefined;
  disabled?: boolean;
  error?: boolean;
  errorLabel?: string;
  sx?: SxProps<Theme>;
  inputStyle?: InputBaseComponentProps;
  onChange?: (value: string | undefined) => void;
};

export const DatePicker = (props: DateInputProps): JSX.Element => {
  const {
    label,
    value,
    disabled,
    error,
    errorLabel,
    inputStyle,
    onChange,
    ...commomProps
  } = props;

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ja}>
      <TextField
        {...commomProps}
        label={label}
        value={value || undefined}
        sx={{
          "& .MuiInputBase-root": {
            "::before": {
              borderBottom: "none",
            },
          },
          ...commomProps.sx,
        }}
        style={{
          minWidth: "0px",
        }}
        error={error}
        type="date"
        InputLabelProps={{
          shrink: true,
        }}
        InputProps={{
          inputProps: {
            style: inputStyle,
          },
        }}
        onChange={(e) => {
          const value = e.target.value;
          onChange && onChange(value);
        }}
        disabled={disabled}
      />
    </LocalizationProvider>
  );
};
